export default __webpack_public_path__ + "static/media/User.2985d63a.svg";